import { Injectable, inject } from '@angular/core';
import { ToastController } from '@ionic/angular/standalone';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private readonly toastController = inject(ToastController);

  public showWarning(message: string) {
    this.toastController
      .create({
        message,
        buttons: [{ text: 'Sluiten', role: 'cancel' }],
        icon: '/assets/custom-icons/warning-yellow.svg',
        duration: 3000,
      })
      .then((toast) => toast.present());
  }
}
